import { Component, OnInit, ViewChild } from '@angular/core';
import { CodeName, sort, validateForm } from '@heda/core-util';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ObservationGroupService } from 'app/mdm/terminology/observation-group/services/observation-group.service';
import { ObservationGroup, ObservationGroupDefinition } from 'app/mdm/lib/observation-group/observation-group';
import { of } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'hw-observation-group-edit',
  templateUrl: './observation-group-edit.component.html',
})
export class ObservationGroupEditComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  public saving: boolean;
  public observationGroup: ObservationGroup;
  public defaultRow = () => {
    const priorities = this.observationGroup.definitions.map((r) => r.priority).filter(Boolean);
    const maxPriority = priorities.length ? Math.max(...priorities) : 0;
    return of({ definition: new CodeName(), priority: maxPriority + 1 } as ObservationGroupDefinition);
  };

  constructor(
    private observationGroupService: ObservationGroupService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.observationGroupService.load(Number(id)).subscribe((resp) => {
        this.observationGroup = resp;
        this.observationGroup.definitions = sort(resp.definitions, 'priority');
      });
    } else {
      this.observationGroup = new ObservationGroup();
    }
  }

  public save(): void {
    if (!validateForm(this.form)) {
      return;
    }
    this.saving = true;
    this.observationGroupService.save(this.observationGroup).subscribe(
      () => {
        this.saving = false;
        this.location.back();
      },
      (_err) => (this.saving = false)
    );
  }

  public exportObservationGroup(): void {
    const ob = Object.assign({}, this.observationGroup);
    saveAs(new Blob([JSON.stringify(ob, null, 2)], { type: 'application/json' }), `${ob.code}.json`);
  }
}
